import Singleton from '../Singleton';
import ListAppService from '../_shared/api/listAppService';
import { PendingRequest } from '../global.d';

export default class PendingClosingService extends Singleton<
  PendingClosingService
> {
  static getSellPending = async (pendingRequest: PendingRequest) => {
    const client = await ListAppService();

    const { offset, size, hasNegotiation, sellingNetworkId } = pendingRequest;

    const request = {
      offset,
      size,
      hasNegotiation,
      sellingNetworkId
    };

    try {
      const response = await client.trade.listSellPending(request);
      return response.data;
    } catch (e) {
      throw new Error(e);
    }
  };

  static getBuyPending = async (pendingRequest: PendingRequest) => {
    const client = await ListAppService();

    const { offset, size, hasNegotiation, sellingNetworkId } = pendingRequest;

    const request = {
      offset,
      size,
      hasNegotiation,
      sellingNetworkId
    };

    try {
      const response = await client.trade.listBuyPending(request);
      return response.data;
    } catch (e) {
      throw new Error(e);
    }
  };
}
